import clsx from 'clsx';
import type { Category } from '@bazaar/shared';

export interface CategoryChipsProps {
  categories: Category[];
  /** `null` means the "All" chip. */
  selectedId: number | null;
  onSelect: (id: number | null) => void;
}

export function CategoryChips({ categories, selectedId, onSelect }: CategoryChipsProps) {
  return (
    <div
      className="flex gap-2 overflow-x-auto py-2 -mx-4 px-4 sm:-mx-6 sm:px-6 lg:mx-0 lg:px-0 lg:flex-wrap"
      role="tablist"
      aria-label="Categories"
    >
      <Chip label="All" selected={selectedId === null} onClick={() => onSelect(null)} />
      {categories.map((c) => (
        <Chip key={c.id} label={c.name} selected={selectedId === c.id} onClick={() => onSelect(c.id)} />
      ))}
    </div>
  );
}

function Chip({ label, selected, onClick }: { label: string; selected: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={selected}
      onClick={onClick}
      className={clsx(
        'shrink-0 min-h-12 px-4 rounded-full font-body font-semibold text-sm border-2 whitespace-nowrap',
        selected ? 'bg-aqua text-teal-dark border-aqua' : 'bg-surface text-muted border-border',
      )}
    >
      {label}
    </button>
  );
}
